import { render } from "./SideBarComponent.vue?vue&type=template&id=35b51e2a"
import script from "./SideBarComponent.vue?vue&type=script&lang=js"
export * from "./SideBarComponent.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./SideBarComponent.vue?vue&type=style&index=0&id=35b51e2a&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__